import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import Layouts from "../../layouts/layouts";
import { Autocomplete, LoadScript } from "@react-google-maps/api";

export default function Create_ticket() {
  const title = "Add Ticket";

  const [formData, setFormData] = useState({
    vehicle_number: "",
    vehicle_id: "",
    driver_id: "",
    assigned_to: "",
    status: "",
    description: "",
    pendingissue: "",
    heading: "",
    category: "",
    comments: "",
    vehicle_odometer: "",
    checklist: [],
    // Accident details
    accident_date: "",
    accident_time: "",
    accident_location: "",
    vehicle_loaded: false,
    laod_details: "",

    tentative_date: "",

    // Insurance / Workshop details
    estimate_amount: "",
    total_amount: "",
    insurance_claim_amount: "",
    company_paid_amount: "",
  });

  const [vehicleImages, setVehicleImages] = useState([]);
  const [vehicleVideos, setVehicleVideos] = useState([]);
  const [loadImages, setLoadImages] = useState([]);
  const [loadDocuments, setLoadDocuments] = useState([]);
  const [estimateAmountImages, setEstimateAmountImages] = useState([]);
  const [componentFiles, setComponentFiles] = useState([]);

  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pendingIssues, setPendingIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checklistItems, setChecklistItems] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState([]);

  const navigate = useNavigate();
  const accidentLocationRef = useRef(null);

  const brad = [{ name: "Home" }, { name: title }];

  // ---------------------------------------------------------
  // Generic input handler
  // ---------------------------------------------------------

  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
      };

      // Automatically calculate Total Amount
      if (name === "insurance_claim_amount" || name === "company_paid_amount") {
        const insuranceAmount =
          parseFloat(
            name === "insurance_claim_amount"
              ? value
              : prev.insurance_claim_amount,
          ) || 0;

        const companyPaidAmount =
          parseFloat(
            name === "company_paid_amount" ? value : prev.company_paid_amount,
          ) || 0;

        updatedData.total_amount = (
          insuranceAmount + companyPaidAmount
        ).toFixed(2);
      }

      return updatedData;
    });
  };

  // ---------------------------------------------------------
  // Validation
  // ---------------------------------------------------------

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vehicle_number) {
      newErrors.vehicle_number = "Vehicle Number is required";
    }

    if (!formData.assigned_to) {
      newErrors.assigned_to = "Assigned To is required";
    }

    if (!formData.status) {
      newErrors.status = "Status is required";
    }

    if (!formData.category) {
      newErrors.category = "Category is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ---------------------------------------------------------
  // Fetch Categories
  // ---------------------------------------------------------

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-ticket-category`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCategories(response.data.data || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      }
    };

    fetchCategories();
  }, []);

  // ---------------------------------------------------------
  // Fetch Users
  // ---------------------------------------------------------

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setUsers(response.data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  // ---------------------------------------------------------
  // Fetch Vehicles
  // ---------------------------------------------------------

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setVehicles(response.data.vehicles || []);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    fetchVehicles();
  }, []);

  // ---------------------------------------------------------
  // Fetch Existing Pending Issues
  // ---------------------------------------------------------
  useEffect(() => {
    const fetchPendingIssues = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/vehicle-tickets`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        console.log("PENDING ISSUE API RESPONSE:", response.data);

        const tickets = Array.isArray(response.data?.tickets)
          ? response.data.tickets
          : [];

        console.log("TOTAL TICKETS:", tickets.length);

        const issueMap = new Map();

        tickets.forEach((ticket) => {
          const pendingIssue = ticket?.pendingissue;

          if (typeof pendingIssue === "string" && pendingIssue.trim() !== "") {
            const issue = pendingIssue.trim();
            const key = issue.toLowerCase();

            if (!issueMap.has(key)) {
              issueMap.set(key, {
                value: issue,
                label: issue,
              });
            }
          }
        });

        const issueOptions = Array.from(issueMap.values());

        console.log("PENDING ISSUE OPTIONS:", issueOptions);

        setPendingIssues(issueOptions);
      } catch (error) {
        console.error("Error fetching pending issues:", error);
        console.error("API ERROR RESPONSE:", error.response?.data);

        setPendingIssues([]);
      }
    };

    fetchPendingIssues();
  }, []);

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/vehicle-defects`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (Array.isArray(response.data.defects)) {
          setChecklistItems(response.data.defects);
        } else {
          console.error(
            "Unexpected data format from checklist API",
            response.data,
          );
          setChecklistItems([]);
        }
      } catch (error) {
        console.error("Error fetching checklist:", error);
        setChecklistItems([]);
      }
    };

    fetchChecklist();
  }, []);

  // ---------------------------------------------------------
  // Vehicle Change
  // ---------------------------------------------------------

  const handleVehicleChange = (selectedOption) => {
    const selectedVehicle = vehicles.find(
      (vehicle) => vehicle._id === selectedOption?.value,
    );

    setFormData((prev) => ({
      ...prev,
      vehicle_number: selectedVehicle?.numberplate || "",
      vehicle_id: selectedVehicle?._id || "",
    }));
  };

  // ---------------------------------------------------------
  // User Change
  // ---------------------------------------------------------

  const handleUserChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      assigned_to: selectedOption?.value || "",
    }));
  };

  const handleDriverChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      driver_id: selectedOption?.value || "",
    }));
  };
  // ---------------------------------------------------------
  // Category Change
  // ---------------------------------------------------------

  const handleCategoryChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      category: selectedOption?.value || "",
    }));
  };

  // ---------------------------------------------------------
  // File handlers
  // ---------------------------------------------------------

  const handleVehicleImagesChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setVehicleImages((prevFiles) => [...prevFiles, ...newFiles]);

    // Allow selecting the same file again if needed
    event.target.value = "";
  };

  const handleVehicleVideosChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setVehicleVideos((prevFiles) => [...prevFiles, ...newFiles]);

    event.target.value = "";
  };

  const handleLoadImagesChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setLoadImages((prevFiles) => [...prevFiles, ...newFiles]);

    event.target.value = "";
  };

  const handleLoadDocumentsChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setLoadDocuments((prevFiles) => [...prevFiles, ...newFiles]);

    event.target.value = "";
  };

  const handleEstimateAmountImagesChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setEstimateAmountImages((prevFiles) => [...prevFiles, ...newFiles]);

    event.target.value = "";
  };

  const handleComponentFilesChange = (event) => {
    const newFiles = Array.from(event.target.files || []);

    setComponentFiles((prevFiles) => [...prevFiles, ...newFiles]);

    event.target.value = "";
  };

  const removeFile = (index, setFiles) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, fileIndex) => fileIndex !== index),
    );
  };
  // ---------------------------------------------------------
  // Submit
  // ---------------------------------------------------------

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        return;
      }

      const formDataToSubmit = new FormData();

      // -----------------------------------------------------
      // Basic ticket fields
      // -----------------------------------------------------

      formDataToSubmit.append("vehicle_number", formData.vehicle_number);

      formDataToSubmit.append("vehicle_id", formData.vehicle_id);

      if (formData.driver_id) {
        formDataToSubmit.append("driver_id", formData.driver_id);
      }

      formDataToSubmit.append("assigned_to", formData.assigned_to);

      formDataToSubmit.append("status", formData.status);

      formDataToSubmit.append("heading", formData.heading);

      formDataToSubmit.append("description", formData.description);

      formDataToSubmit.append("pendingissue", formData.pendingissue || "");

      formDataToSubmit.append("category", formData.category);

      formDataToSubmit.append("checklist", JSON.stringify(formData.checklist));

      if (formData.comments) {
        formDataToSubmit.append(
          "comments",
          JSON.stringify([
            {
              text: formData.comments,
              date: new Date(),
            },
          ]),
        );
      }

      if (formData.vehicle_odometer) {
        formDataToSubmit.append("vehicle_odometer", formData.vehicle_odometer);
      }

      // -----------------------------------------------------
      // Tentative Date
      // -----------------------------------------------------

      if (formData.tentative_date) {
        formDataToSubmit.append("tentative_date", formData.tentative_date);
      }

      // -----------------------------------------------------
      // Insurance / Workshop Amounts
      // -----------------------------------------------------

      formDataToSubmit.append(
        "estimate_amount",
        formData.estimate_amount || "0",
      );

      formDataToSubmit.append("total_amount", formData.total_amount || "0");

      formDataToSubmit.append(
        "insurance_claim_amount",
        formData.insurance_claim_amount || "0",
      );

      formDataToSubmit.append(
        "company_paid_amount",
        formData.company_paid_amount || "0",
      );

      // -----------------------------------------------------
      // Accident object
      // -----------------------------------------------------

      const accidentData = {
        accident_date: formData.accident_date || "",
        accident_time: formData.accident_time || "",
        accident_location: formData.accident_location || "",
        vehicle_loaded: Boolean(formData.vehicle_loaded),
        load_details: formData.load_details || "",
      };

      formDataToSubmit.append("accident", JSON.stringify(accidentData));

      // -----------------------------------------------------
      // Service center
      // -----------------------------------------------------

      formDataToSubmit.append("service_center", JSON.stringify({}));

      // -----------------------------------------------------
      // Vehicle Images
      // Backend:
      // req.files?.vehicle_images
      // -----------------------------------------------------

      vehicleImages.forEach((file) => {
        formDataToSubmit.append("vehicle_images", file);
      });

      // -----------------------------------------------------
      // Vehicle Videos
      // Backend:
      // req.files?.vehicle_videos
      // -----------------------------------------------------

      vehicleVideos.forEach((file) => {
        formDataToSubmit.append("vehicle_videos", file);
      });

      // -----------------------------------------------------
      // Load Images
      // Backend:
      // req.files?.load_images
      // -----------------------------------------------------

      loadImages.forEach((file) => {
        formDataToSubmit.append("load_images", file);
      });

      // -----------------------------------------------------
      // Load Documents
      //
      // Can be:
      // PDF
      // DOC
      // DOCX
      // XLS
      // XLSX
      // JPG
      // PNG
      // etc.
      // -----------------------------------------------------

      loadDocuments.forEach((file) => {
        formDataToSubmit.append("load_documents", file);
      });

      // -----------------------------------------------------
      // Estimate Amount Images / Documents
      // Backend: req.files?.estimate_amount_image
      // -----------------------------------------------------

      estimateAmountImages.forEach((file) => {
        formDataToSubmit.append("estimate_amount_image", file);
      });

      // -----------------------------------------------------
      // Component Files
      // Backend: req.files?.components
      // -----------------------------------------------------

      componentFiles.forEach((file) => {
        formDataToSubmit.append("components", file);
      });
      // -----------------------------------------------------
      // IMPORTANT:
      // Do NOT manually set Content-Type.
      //
      // Browser will automatically set:
      // multipart/form-data;
      // boundary=...
      // -----------------------------------------------------

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v2/vehicle-ticket/new`,
        formDataToSubmit,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        navigate("/ticket");
      }
    } catch (error) {
      console.error("Error creating ticket:", error);

      console.error("Server response:", error.response?.data);

      alert(error.response?.data?.message || "Unable to create ticket.");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // Select options
  // ---------------------------------------------------------

  const vehicleOptions = vehicles.map((vehicle) => ({
    value: vehicle._id,
    label: vehicle.numberplate,
  }));

  const userOptions = users.map((user) => ({
    value: user._id,
    label: `${user.name || "Unknown Name"} ${
      user.phonenumber ? `(${user.phonenumber})` : ""
    }`,
  }));

  const driverOptions = users.map((user) => ({
    value: user._id,
    label: `${user.name || "Unknown Name"} ${
      user.phonenumber ? `(${user.phonenumber})` : ""
    }`,
  }));

  const categoryOptions = categories.map((category) => ({
    value: category._id,
    label: category.name,
  }));

  const selectedVehicle =
    vehicleOptions.find((option) => option.value === formData.vehicle_id) ||
    null;

  const selectedUser =
    userOptions.find((option) => option.value === formData.assigned_to) || null;

  const selectedDriver =
    driverOptions.find((option) => option.value === formData.driver_id) || null;
  const selectedCategory =
    categoryOptions.find((option) => option.value === formData.category) ||
    null;

  const handleAccidentLocationSelect = () => {
    if (!accidentLocationRef.current) {
      return;
    }

    const place = accidentLocationRef.current.getPlace();

    if (!place) {
      return;
    }

    console.log("Selected Place:", place);

    setFormData((prev) => ({
      ...prev,
      accident_location: place.name || "",
    }));
  };

  // ---------------------------------------------------------
  // UI
  // ---------------------------------------------------------

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_BASE_API}
      libraries={["places"]}
    >
      <>
        <Layouts />

        <div className="container-fluid">
          <Breadcrumb title={title} brad={brad} />

          <form
            className="card"
            style={{
              borderTop: "2px solid #4723d9",
            }}
            onSubmit={onSubmitHandler}
          >
            {/* Header */}

            <div className="card-header d-flex justify-content-between border-bottom pb-1">
              <div>{title}</div>

              <button
                type="button"
                className="btn btn-info btn-sm"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>

            <div className="card-body">
              <div className="row">
                {/* ------------------------------------------------ */}
                {/* Vehicle */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Vehicle *</b>
                  </label>

                  <Select
                    options={vehicleOptions}
                    value={selectedVehicle}
                    onChange={handleVehicleChange}
                    classNamePrefix="select"
                    placeholder="Select Vehicle"
                  />

                  {errors.vehicle_number && (
                    <small className="text-danger">
                      {errors.vehicle_number}
                    </small>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Assigned User */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Assigned User *</b>
                  </label>

                  <Select
                    options={userOptions}
                    value={selectedUser}
                    onChange={handleUserChange}
                    classNamePrefix="select"
                    placeholder="Select Assigned User"
                  />

                  {errors.assigned_to && (
                    <small className="text-danger">{errors.assigned_to}</small>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Category */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Category *</b>
                  </label>

                  <Select
                    options={categoryOptions}
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    classNamePrefix="select"
                    placeholder="Select Category"
                  />

                  {errors.category && (
                    <small className="text-danger">{errors.category}</small>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Checklist */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Checklist</b>
                  </label>

                  <Select
                    isMulti
                    isSearchable
                    placeholder="Select checklist items..."
                    options={checklistItems.map((item) => ({
                      value: item._id,
                      label: item.defectName,
                    }))}
                    value={checklistItems
                      .filter((item) =>
                        formData.checklist.includes(item.defectName),
                      )
                      .map((item) => ({
                        value: item._id,
                        label: item.defectName,
                      }))}
                    onChange={(selectedOptions) => {
                      setFormData((prev) => ({
                        ...prev,
                        checklist: selectedOptions
                          ? selectedOptions.map((option) => option.label)
                          : [],
                      }));
                    }}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isClearable
                    noOptionsMessage={() => "No checklist items found"}
                    className="mt-2"
                    classNamePrefix="checklist-select"
                    components={{
                      Option: (props) => {
                        const { data, isSelected } = props;

                        return (
                          <components.Option {...props}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isSelected}
                                readOnly
                              />

                              <span>{data.label}</span>
                            </div>
                          </components.Option>
                        );
                      },

                      MenuList: (props) => {
                        return (
                          <components.MenuList {...props}>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "0",
                              }}
                            >
                              {props.children}
                            </div>
                          </components.MenuList>
                        );
                      },
                    }}
                  />
                </div>

                {/* ------------------------------------------------ */}
                {/* Driver ID */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Driver</b>
                  </label>

                  <Select
                    name="driver_id"
                    options={driverOptions}
                    value={selectedDriver}
                    onChange={handleDriverChange}
                    classNamePrefix="select"
                    placeholder="Select Driver"
                    isClearable
                  />
                </div>

                {/* ------------------------------------------------ */}
                {/* Heading */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Title *</b>
                  </label>

                  <input
                    type="text"
                    name="heading"
                    className="form-control"
                    placeholder="Title"
                    value={formData.heading}
                    onChange={onChangeHandler}
                    required
                  />
                </div>

                {/* ------------------------------------------------ */}
                {/* Status */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Status *</b>
                  </label>

                  <select
                    name="status"
                    className={`form-control ${
                      errors.status ? "is-invalid" : ""
                    }`}
                    value={formData.status}
                    onChange={onChangeHandler}
                  >
                    <option value="">Select Status</option>

                    <option value="In-Progress">In-Progress</option>

                    <option value="Todo">Todo</option>

                    <option value="Done">Done</option>
                  </select>

                  {errors.status && (
                    <div className="invalid-feedback">{errors.status}</div>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Odometer */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Vehicle Odometer</b>
                  </label>

                  <input
                    type="number"
                    name="vehicle_odometer"
                    className="form-control"
                    placeholder="Vehicle Odometer"
                    value={formData.vehicle_odometer}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* ------------------------------------------------ */}
                {/* Description */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Description *</b>
                  </label>

                  <textarea
                    name="description"
                    rows="3"
                    className="form-control"
                    placeholder="Description"
                    value={formData.description}
                    onChange={onChangeHandler}
                    required
                  />
                </div>
                {/* ------------------------------------------------ */}
                {/* Pending Issue */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Pending Issue</b>
                  </label>

                  <CreatableSelect
                    options={pendingIssues}
                    placeholder="Select or Add Pending Issue"
                    value={
                      formData.pendingissue
                        ? {
                            value: formData.pendingissue,
                            label: formData.pendingissue,
                          }
                        : null
                    }
                    onChange={(option) => {
                      setFormData((prev) => ({
                        ...prev,
                        pendingissue: option?.value || "",
                      }));
                    }}
                    onCreateOption={(inputValue) => {
                      const trimmedValue = inputValue.trim();

                      if (!trimmedValue) return;

                      const newIssue = {
                        value: trimmedValue,
                        label: trimmedValue,
                      };

                      setPendingIssues((prev) => {
                        const exists = prev.some(
                          (item) =>
                            item.value?.toLowerCase() ===
                            trimmedValue.toLowerCase(),
                        );

                        if (exists) {
                          return prev;
                        }

                        return [...prev, newIssue];
                      });

                      setFormData((prev) => ({
                        ...prev,
                        pendingissue: trimmedValue,
                      }));
                    }}
                    isClearable
                    isSearchable
                    classNamePrefix="select"
                    noOptionsMessage={() => "No pending issues found"}
                  />
                </div>

                {/* ------------------------------------------------ */}
                {/* Comment */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Comment</b>
                  </label>

                  <textarea
                    name="comments"
                    rows="3"
                    className="form-control"
                    placeholder="Comment"
                    value={formData.comments}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* ================================================= */}
                {/* INSURANCE / WORKSHOP DETAILS */}
                {/* ================================================= */}

                <div className="col-12 mt-4">
                  <hr />

                  <h5 className="mb-3">Insurance / Workshop Details</h5>
                </div>

                {/* Tentative Date */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Tentative Date</b>
                  </label>

                  <input
                    type="date"
                    name="tentative_date"
                    className="form-control"
                    value={formData.tentative_date}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Estimate Amount */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Estimate Amount</b>
                  </label>

                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="estimate_amount"
                    className="form-control"
                    placeholder="Enter estimate amount"
                    value={formData.estimate_amount}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Total Amount */}
                {/* Total Amount */}

                {/* Insurance Claim Amount */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Insurance Claim Amount</b>
                  </label>

                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="insurance_claim_amount"
                    className="form-control"
                    placeholder="Enter insurance claim amount"
                    value={formData.insurance_claim_amount}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Company Paid Amount */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Company Paid Amount</b>
                  </label>

                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    name="company_paid_amount"
                    className="form-control"
                    placeholder="Enter company paid amount"
                    value={formData.company_paid_amount}
                    onChange={onChangeHandler}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Total Amount</b>
                  </label>

                  <input
                    type="number"
                    name="total_amount"
                    className="form-control"
                    value={formData.total_amount}
                    readOnly
                  />

                  <small className="text-muted">
                    Automatically calculated from Insurance Amount + Company
                    Paid Amount
                  </small>
                </div>

                {/* Estimate Files */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Estimate Documents / Images</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="
      image/*,
      application/pdf,
      application/msword,
      application/vnd.openxmlformats-officedocument.wordprocessingml.document,
      application/vnd.ms-excel,
      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    "
                    onChange={handleEstimateAmountImagesChange}
                  />

                  <small className="text-muted">
                    Upload estimate images or documents.
                  </small>

                  {estimateAmountImages.length > 0 && (
                    <div className="mt-3">
                      {estimateAmountImages.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-file me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() =>
                              removeFile(index, setEstimateAmountImages)
                            }
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Component Files */}
                <div className="col-md-6 mt-3">
                  <label className="form-label">
                    <b>Component Files</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="
      image/*,
      application/pdf,
      application/msword,
      application/vnd.openxmlformats-officedocument.wordprocessingml.document,
      application/vnd.ms-excel,
      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    "
                    onChange={handleComponentFilesChange}
                  />

                  <small className="text-muted">
                    Upload component images or documents.
                  </small>

                  {componentFiles.length > 0 && (
                    <div className="mt-3">
                      {componentFiles.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-file me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeFile(index, setComponentFiles)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* ================================================= */}
                {/* ACCIDENT DETAILS */}
                {/* ================================================= */}

                <div className="col-12 mt-4">
                  <hr />

                  <h5 className="mb-3">Accident Details</h5>
                </div>

                {/* Accident Date */}
                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    <b>Accident Date</b>
                  </label>

                  <input
                    type="date"
                    name="accident_date"
                    className="form-control"
                    value={formData.accident_date}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Accident Time */}
                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    <b>Accident Time</b>
                  </label>

                  <input
                    type="time"
                    name="accident_time"
                    className="form-control"
                    value={formData.accident_time}
                    onChange={onChangeHandler}
                  />
                </div>

                {/* Accident Location */}
                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    <b>Accident Location</b>
                  </label>

                  <Autocomplete
                    onLoad={(autocomplete) => {
                      accidentLocationRef.current = autocomplete;
                    }}
                    onPlaceChanged={handleAccidentLocationSelect}
                    options={{
                      componentRestrictions: {
                        country: "in",
                      },
                      fields: ["name"],
                      types: ["establishment", "geocode"],
                    }}
                  >
                    <input
                      type="text"
                      name="accident_location"
                      className="form-control"
                      placeholder="Enter accident location"
                      value={formData.accident_location}
                      onChange={onChangeHandler}
                    />
                  </Autocomplete>
                </div>

                {/* Vehicle Loaded */}
                <div className="col-md-4 mt-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="vehicle_loaded"
                      name="vehicle_loaded"
                      className="form-check-input mt-0"
                      checked={formData.vehicle_loaded}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          vehicle_loaded: e.target.checked,
                          // Clear load details when unchecked
                          load_details: e.target.checked
                            ? prev.load_details
                            : "",
                        }))
                      }
                    />

                    <label
                      htmlFor="vehicle_loaded"
                      className="form-check-label mb-0"
                    >
                      <b>Vehicle was loaded</b>
                    </label>
                  </div>

                  <small className="text-muted d-block mt-1">
                    {formData.vehicle_loaded
                      ? "Vehicle Loaded: Yes"
                      : "Vehicle Loaded: No"}
                  </small>
                </div>

                {/* Load Details - Only show when vehicle is loaded */}
                {formData.vehicle_loaded && (
                  <div className="col-md-8 mt-4">
                    <label className="form-label">
                      <b>Load Details</b>
                    </label>

                    <input
                      type="text"
                      name="load_details"
                      className="form-control"
                      placeholder="Enter load details"
                      value={formData.load_details}
                      onChange={onChangeHandler}
                    />

                    <small className="text-muted">
                      Enter details about the load carried by the vehicle.
                    </small>
                  </div>
                )}
                {/* ================================================= */}
                {/* INSURANCE / ACCIDENT FILES */}
                {/* ================================================= */}

                <div className="col-12 mt-4">
                  <hr />

                  <h5 className="mb-3">Accident / Insurance Documents</h5>
                </div>

                {/* ------------------------------------------------ */}
                {/* Vehicle Images */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Vehicle Images</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="image/*"
                    onChange={handleVehicleImagesChange}
                  />

                  <small className="text-muted">
                    You can upload multiple vehicle images.
                  </small>

                  {vehicleImages.length > 0 && (
                    <div className="mt-3">
                      {vehicleImages.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-file me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeFile(index, setVehicleImages)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Vehicle Videos */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Vehicle Videos</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="video/*"
                    onChange={handleVehicleVideosChange}
                  />

                  <small className="text-muted">
                    You can upload multiple videos.
                  </small>

                  {vehicleVideos.length > 0 && (
                    <div className="mt-3">
                      {vehicleVideos.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-video-camera me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeFile(index, setVehicleVideos)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Load Images */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Load Images</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="image/*"
                    onChange={handleLoadImagesChange}
                  />

                  <small className="text-muted">
                    Upload images of the vehicle load.
                  </small>

                  {loadImages.length > 0 && (
                    <div className="mt-3">
                      {loadImages.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-file-image-o me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeFile(index, setLoadImages)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Load Documents */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mt-3">
                  <label>
                    <b>Load Documents</b>
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="
                    image/*,
                    application/pdf,
                    application/msword,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                  "
                    onChange={handleLoadDocumentsChange}
                  />

                  <small className="text-muted">
                    PDF, Word, Excel, images and other supported documents.
                  </small>

                  {loadDocuments.length > 0 && (
                    <div className="mt-3">
                      {loadDocuments.map((file, index) => (
                        <div
                          key={`${file.name}-${index}`}
                          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                        >
                          <div>
                            <i className="fa fa-file me-2"></i>
                            <span>{file.name}</span>

                            <small className="text-muted ms-2">
                              ({(file.size / 1024 / 1024).toFixed(2)} MB)
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeFile(index, setLoadDocuments)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* ------------------------------------------------ */}
                {/* Submit */}
                {/* ------------------------------------------------ */}

                <div className="col-12 mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={loading}
                  >
                    {loading ? "Creating Ticket..." : "Add Ticket"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    </LoadScript>
  );
}
